import * as React from "react";
import PieChart from "@cloudscape-design/components/pie-chart";
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import { Container } from "@cloudscape-design/components";
import { ListUser } from "../data/data";

export interface VariationTableProps {
  ListUser: ListUser[];
}

interface DataItem {
  title: string;
  percentage: number;
  value: number;
}

export default function UserChart({ ListUser }: VariationTableProps) {
  // Count occurrences of each role
  const roleCounts = ListUser.reduce(
    (acc, user) => {
      acc[user.AccessRole] = (acc[user.AccessRole] || 0) + 1;
      return acc;
    },
    {} as { [key: string]: number }
  );

  const totalUsers = ListUser.length;

  // Calculate percentages and prepare data
  const data: DataItem[] = Object.keys(roleCounts).map((role) => ({
    title: role,
    value: roleCounts[role],
    percentage: (roleCounts[role] / totalUsers) * 100,
  }));

  return (
    <Container>
      <div style={{ textAlign: "center" }}>
        <h3 style={{ marginTop: "0px" }}>Total Users</h3>
        <PieChart
          data={data}
          visibleSegments={data}
          ariaDescription="Pie chart showing the distribution of user roles."
          ariaLabel="User roles distribution chart"
          hideFilter
          hideTitles
          hideLegend
          innerMetricDescription="Total Users"
          innerMetricValue={totalUsers.toString()}
          size="small"
          variant="donut"
          empty={
            <Box textAlign="center" color="inherit">
              <b>No data available</b>
              <Box variant="p" color="inherit">
                There is no data available
              </Box>
            </Box>
          }
          noMatch={
            <Box textAlign="center" color="inherit">
              <b>No matching data</b>
              <Box variant="p" color="inherit">
                There is no matching data to display
              </Box>
              <Button>Clear filter</Button>
            </Box>
          }
        />
      </div>
    </Container>
  );
}